module.exports = __webpack_public_path__ + "static/media/ex7.76574fbc.jpg";